module.exports = __webpack_public_path__ + "static/media/folder_settings_2.e9e02b1d.ico";